
import programQuery from '~/graphql/queries/radio/program.gql';
import videosQuery from '~/graphql/queries/video/videos.gql';
import carouselProgramsQuery from '~/graphql/queries/radio/carouselPrograms.gql';

export default {
  auth: false,
  apollo: {
    program: {
      query: programQuery,
      variables() {
        return {
          slug: this.$route?.params?.slug,
        };
      },
      update: data => data.program ?? {},
      result({data: {program}}) {
        if (!program) {
          return this.$nuxt.error({statusCode: 404, message: 'Pagina niet gevonden'});
        }
      },
    },
    programs: {
      query: carouselProgramsQuery,
      variables() {
        return {
          notSlug: this.$route?.params?.slug,
        };
      },
    },
    videos: {
      query: videosQuery,
      variables() {
        return {
          programSlug: this.$route?.params?.slug,
        };
      },
    },
  },
  data: vm => ({
    internalVideosPageCounter: 1,
    program: {},
    programs: [],
    videos: [],
  }),
  methods: {
    isVideoActivatable(video) {
      return this.$dateFns.isPast(this.$dateFns.parseISO(video.start));
    },
    handleFetchMoreVideos(program) {
      this.$apollo.queries.videos.fetchMore({
        variables: {
          page: ++this.internalVideosPageCounter,
        },
        updateQuery: (previousResult, {fetchMoreResult}) => ({
          videos: {
            ...fetchMoreResult.videos,
            data: [...previousResult.videos.data, ...fetchMoreResult.videos.data],
          },
        }),
      });
      this.$gtagConsent('event', 'video_history', {program: program.title});
    },
  },
};
